import React from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '../../../../../lib/utils';
import {
  borderPrimary,
  darkerBG,
  mediumText,
  redTextColor,
  secondaryText,
  smallTextSize,
} from '../../../../../styling/stylingHelper';
import { AccessRequestStatus } from '../../../../../stores/appStaffStore';
import { useStaffStatusActions } from '../../hooks/useStaffStatusActions';
import { SectionHeading } from './sectionStyles';

interface StaffAccountStatusSectionProps {
  staffId: string;
  status: AccessRequestStatus;
  onDeleteUser: () => void;
}

const StaffAccountStatusSection: React.FC<StaffAccountStatusSectionProps> = ({
  staffId,
  status,
  onDeleteUser,
}) => {
  const { t } = useTranslation();
  const { approve, reject, setPending } = useStaffStatusActions(staffId);

  const buttonBase = cn(smallTextSize, mediumText, 'leading-5 py-2.5 rounded-xl border transition-colors');
  const inactiveClass = cn(borderPrimary, secondaryText, darkerBG, 'hover:opacity-90');

  return (
    <section>
      <div className="flex items-center justify-between mb-3 sm:mb-4">
        <SectionHeading>{t('staff.accountStatus')}</SectionHeading>
        <button
          type="button"
          onClick={onDeleteUser}
          className={cn(mediumText, 'text-[14px] leading-5 underline underline-offset-2', redTextColor)}
        >
          {t('staff.deleteUserLink')}
        </button>
      </div>

      <div className="grid grid-cols-3 gap-2">
        <button
          type="button"
          onClick={approve}
          className={cn(
            buttonBase,
            status === 'approved'
              ? 'bg-darkGreenColor dark:bg-darkGreenColor-dark border-darkGreenColor dark:border-darkGreenColor-dark text-white dark:text-white'
              : inactiveClass
          )}
        >
          {t('staff.filter.approved')}
        </button>
        <button
          type="button"
          onClick={setPending}
          className={cn(
            buttonBase,
            status === 'pending'
              ? 'bg-yellow-500 dark:bg-yellow-600 border-yellow-500 dark:border-yellow-600 text-white dark:text-white'
              : inactiveClass
          )}
        >
          {t('staff.filter.pending')}
        </button>
        <button
          type="button"
          onClick={reject}
          className={cn(
            buttonBase,
            status === 'rejected'
              ? 'bg-red-600 dark:bg-red-700 border-red-600 dark:border-red-700 text-white dark:text-white'
              : inactiveClass
          )}
        >
          {t('staff.filter.rejected')}
        </button>
      </div>
    </section>
  );
};

export default StaffAccountStatusSection;
